// import { Globals } from '@/globals.js';
export const Globals = {
    API: {
        ROOT: process.env.NODE_ENV === 'production'
        ? 'https://price.sibdt.com/api/'
        : 'http://127.0.0.1:8000/api/',
        MAIN: 'main/',
        AUTH: 'auth/',
        ADMIN: 'admin/',
    },
    RECAPTCHA_SITE_KEY: process.env.NODE_ENV === 'production' ?
        '6Lc6KpUUAAAAAFfmFi4ggawf4FrgbsV-MPRy-ASK' : '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
};